import $ from 'jquery';


export default () => {
    (function ($) {

        $('.form-control')
            .removeAttr('placeholder')
            .each(function () {
                if ($(this).val()) {
                    $(this).parents('.form-group').find('label').toggleClass('focus-in', true);
                }
            })
            .focus(function () {

                $(this).parents('.form-group').find('label').toggleClass('focus-in', true);
            });

        $('.form-control:not(.hasDatePicker)').blur(function () {
            if (!$(this).val()) {
                $(this).parents('.form-group').find('label').toggleClass('focus-in', false);
            }
        });

    })(jQuery);
};



// WEBPACK FOOTER //
// ./scripts/libs/form.js